import React, { useEffect } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { getAuthTokenFromStorage } from '../../utils';

import './style.scss';

const heartFilled = require('../../assets/icons/heart-filled.png');
const locationPin = require('../../assets/icons/pin-filled.png');

const MyElections = (props) => {
  const {
    allElections,
    history,
    isLoggedIn,
    queriedElections,
    setSelectedElection,
    user,
  } = props;

  useEffect(() => {
    if (allElections.length > 0 && !isLoggedIn && !getAuthTokenFromStorage()) {
      history.push('/elections');
    }
  }, [allElections, isLoggedIn]);

  const userElectionIds = user.saved_elections || [];

  const myElections = [
    ...(user.user_elections || []).map(el => ({ ...el, address: true })),
    ...allElections.filter(election => userElectionIds.includes(election._id)).map(el => ({ ...el, saved: true })),
    ...Object.values(queriedElections || {}),
  ].filter((election, index, self) => index === self.findIndex(el => el._id === election._id));

  return (
    <div id="my-elections-content">
      <h1>My Elections</h1>
      <div id="content-container">
        {myElections.length === 0 ? (
          <div id="no-saved-elections">
            <h3>Looks like you don&apos;t have any saved elections.</h3>
            <p>You can favorite elections by clicking the heart icon when on an election page.</p>
            <p>If you save your street address in your profile, elections in your jurisdiction will also appear here.</p>
            <div id="link-to-elections">
              <Link to="/elections">Explore Upcoming Elections</Link>
            </div>
          </div>
        ) : null}
        <div id="info-container">
          {myElections.map((election) => {
            const {
              title,
              date,
              saved,
              address,
            } = election;

            return (
              <>
                <div className="election-preview"
                  key={election._id}
                  onClick={() => {
                    setSelectedElection(election._id);
                    history.push(`/elections/${election._id}`);
                  }}
                >
                  <h4>{title}</h4>
                  <p>{moment(date).format('MMMM Do, YYYY')}</p>
                </div>
                {(saved || address) && (
                  <div>
                    {saved && <img id="saved-icon" src={heartFilled} alt="filled heart" />}
                    {address && <img id="address-icon" src={locationPin} alt="address pin" />}
                  </div>
                )}
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MyElections;
